import {
  CartContactInfoPart,
  CartDeliveryPart,
  InfoText,
} from '@bart.sk-eshop/eshop-defaults';
import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import { connect } from 'react-redux';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import API, { ThenArg } from '../../services/API';
import { withTheme } from 'styled-components';
import {
  cartDelPayInfoByIdSelector,
  cartDelPayInfoIdsSelector,
  cartDelPayInfoIsFetchingSelector,
  fetchDeliveryPaymentInfo,
  freeDeliveryRemainingAmountSelector,
  updateCart,
} from './cartSlice';
import {
  ga4AddShippingInfo,
  ga4AddPaymentInfo,
} from '@bart.sk-eshop/react-online-marketing';
import { getGoogleAdsId } from '../../configureTagManager';
import { prop } from '../../utilities';
import { fetchCustomerDetails } from '../MyAccount/myAccountSlice';
import { InfoType } from '@bart.sk-eshop/eshop-defaults/lib/components/Zemplin/General/InfoText';
import { rem } from 'polished';
import styled from '../../theme/styled-components';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';

interface Props {
  user: any;
  dispatch: any;
  data: ThenArg<typeof API.getCart> | null;
  isFetching: boolean;
  delAndPayInfoIds: string[];
  delAndPayInfoById: Record<string, ThenArg<typeof API.getDeliveryPaymentInfo>>;
  isFetchingDelAndPayInfo: boolean;
  freeDelivery: number;
  deliveryAddresses: any;
  deliveryAddressesIsFetching: boolean;
  showProblems: boolean;
  dispatchCartContactInfo: any;
  cartContactInfo: any;
  openGlsWidget: () => void;
  theme: any;
}

class CartCheckout extends React.Component<Props> {
  public static async getInitialProps(props) {
    const { dispatch } = props;
    try {
      await dispatch(fetchDeliveryPaymentInfo());
      await dispatch(fetchCustomerDetails());
      return;
    } catch (exp) {
      console.log(exp);
      return;
    }
  }

  public async componentDidUpdate(prevProps) {
    const { data, dispatch } = this.props;

    const paymentId = prop(data, 'payment.id', null);
    const prevPropsPaymentId = prop(prevProps, 'data.payment.id', null);

    if (paymentId !== prevPropsPaymentId) {
      await dispatch(fetchDeliveryPaymentInfo(false));
    }
  }

  public onChooseZasielkovna = a => {
    if (a) {
      const cart = this.props.data;
      const lang = prop(cart, 'lang', 'sk');
      const deliveryId = lang === 'cz' ? 'ZASIELKOVNA_CZ' : 'ZASIELKOVNA';
      this.props.dispatch(
        updateCart({
          ...this.props.data,
          delivery: { id: deliveryId },
          pickup_id: `${a.id}`,
          pickup_payload: a,
        }),
      );
    }
  };

  public openZasielkovna = () => {
    const cart = this.props.data;
    const country = prop(cart, 'lang', 'sk');
    const lang = country === 'cz' ? 'cs' : 'sk';
    window.Packeta.Widget.pick(
      process.env.REACT_APP_PUBLIC_ZASIELKOVNA_API_KEY,
      this.onChooseZasielkovna,
      { country: country, language: lang },
    );
  };

  public render() {
    const {
      data,
      isFetching,
      delAndPayInfoIds,
      delAndPayInfoById,
      isFetchingDelAndPayInfo,
      freeDelivery,
      deliveryAddresses,
      deliveryAddressesIsFetching,
      dispatchCartContactInfo,
      showProblems,
      cartContactInfo,
      openGlsWidget,
      user,
    } = this.props;

    if (!data) {
      return (
        <>
          <MetaTags tags={{ title: __('Pokladňa') }} />
          <InfoText type={InfoType.ERROR} info={__('Košík nebol nájdený')} />
        </>
      );
    }
    return (
      <>
        <MetaTags tags={{ title: __('Pokladňa') }} />
        <CartContactInfoPart
          data={data}
          isFetching={isFetching}
          updateCart={this.updateCart}
          deliveryAddresses={deliveryAddresses}
          deliveryAddressesIsFetching={deliveryAddressesIsFetching}
          showProblems={showProblems}
          dispatchCartContactInfo={dispatchCartContactInfo}
          cartContactInfo={cartContactInfo}
          user={user}
        />
        <CartDeliveryPart
          data={data}
          isFetching={isFetching}
          delAndPayInfoIds={delAndPayInfoIds}
          delAndPayInfoById={delAndPayInfoById}
          isFetchingDelAndPayInfo={isFetchingDelAndPayInfo}
          updateCart={this.updateCart}
          freeDelivery={freeDelivery}
          openZasielkovnaWidget={this.openZasielkovna}
          openGlsWidget={openGlsWidget}
        />
      </>
    );
  }

  private updateCart = data => {
    this.props.dispatch(updateCart(data, true));
    const currency = prop(data, 'currency', 'EUR');
    if (data.delivery && !data.payment) {
      if (window.gtag) {
        if (data) {
          /// @ts-ignore
          let gData = data.items.filter(d => !d.isFromSale);
          ga4AddShippingInfo(
            gData,
            data.delivery.id,
            getGoogleAdsId(),
            currency,
          );
        }
      }
    }
    if (data.payment) {
      if (window.gtag) {
        if (data) {
          /// @ts-ignore
          let gData = data.items.filter(d => !d.isFromSale);
          ga4AddPaymentInfo(gData, data.payment.id, getGoogleAdsId(), currency);
        }
      }
    }
  };
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    delAndPayInfoIds: cartDelPayInfoIdsSelector(state),
    delAndPayInfoById: cartDelPayInfoByIdSelector(state),
    isFetchingDelAndPayInfo: cartDelPayInfoIsFetchingSelector(state),
    freeDelivery: freeDeliveryRemainingAmountSelector(state),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'CartCheckout' })(withTheme(CartCheckout)),
);
